import config from "./config.json";

export const { serverPath, appURL, captchaKey } = config[process.env.REACT_APP_NODE_ENV];
